import { useNavigate } from "react-router-dom";
import { useState, useCallback, useEffect } from "react";
import axios from "axios";

import MonthPickerModal from "../../components/MonthPickerModal/MonthPickerModal";
import Generale from "./Generale/Generale";
import Dettaglio from "./Dettaglio/Dettaglio";
import FiltroCategorie from "../../components/FiltroCategorie/FiltroCategorie";
import { MOCKED_AMBIENTE_CATEGORIES } from "../../mocks/MockedCategories";
import Select, { components } from "react-select";

import "../OperazioniHr/OperazioniHr.css";

const MultiValueContainer = ({ children, selectProps, data, ...props }) => {
    const values = selectProps.value || [];
    const index = values.findIndex(v => v.value === data.value);

    if (index < 2) {
        return <components.MultiValue selectProps={selectProps} data={data} {...props}>{children}</components.MultiValue>;
    }
    if (index === 2 && values.length > 2) {
        return (
            <div className="oper-hr-select-more-badge">
                +{values.length - 2}
            </div>
        );
    }
    return null;
};

const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

const monthToFirstDay = (monthValue) => monthValue ? `${monthValue}-01` : "";

const monthToLastDay = (monthValue) => {
    if (!monthValue) return "";
    const [year, month] = monthValue.split("-").map(Number);
    return `${monthValue}-${String(new Date(year, month, 0).getDate()).padStart(2, "0")}`;
};

const dateToMonth = (dateValue) => dateValue ? dateValue.substring(0, 7) : "";

const getDefaultDateRange = () => {
    return {
        from: "2024-01-01",
        to: "2024-12-31",
    };
};

const defaultDates = getDefaultDateRange();

const Ambiente = () => {
    const navigate = useNavigate();

    const [showInfoModal, setShowInfoModal] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState("");

    const [showFiltersPanel, setShowFiltersPanel] = useState(false);
    const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001/api";

    // Date
    const [fromDate, setFromDate] = useState(defaultDates.from);
    const [toDate, setToDate] = useState(defaultDates.to);

    // Select multi-scelta
    const [selectedSettore, setSelectedSettore] = useState([]);
    const [selectedTipContratto, setSelectedTipContratto] = useState([]);
    const [selectedCommessa, setSelectedCommessa] = useState([]);

    const handleFromMonthChange = (e) => setFromDate(monthToFirstDay(e.target.value));
    const handleToMonthChange = (e) => setToDate(monthToLastDay(e.target.value));

    // Opzioni dropdown (verranno populate dal backend)
    const [filterOptions, setFilterOptions] = useState({
        settore: [],
        tipContratto: [],
        commessa: [],
    });

    useEffect(() => {
        const fetchFilters = async () => {
            try {
                const res = await axios.get(`${API_URL}/ambiente/filters`);
                setFilterOptions({
                    settore: res.data.settore.map(s => ({ value: s.id, label: s.valore })),
                    tipContratto: res.data.tipContratto.map(t => ({ value: t.id, label: t.valore })),
                    commessa: res.data.commessa.map(c => ({ value: c.id, label: c.valore })),
                });
            } catch (error) {
                console.error("Errore nel caricamento dei filtri:", error);
            }
        };
        fetchFilters();
    }, [API_URL]);

    const handleApply = useCallback(() => {
        setAppliedFilters({
            fromDate, toDate,
            settore: selectedSettore,
            tipContratto: selectedTipContratto,
            commessa: selectedCommessa,
        });
    }, [fromDate, toDate, selectedSettore, selectedTipContratto, selectedCommessa]);

    const handleReset = useCallback(() => {
        setFromDate(defaultDates.from);
        setToDate(defaultDates.to);
        setSelectedSettore([]);
        setSelectedTipContratto([]);
        setSelectedCommessa([]);
        setAppliedFilters({
            fromDate: defaultDates.from,
            toDate: defaultDates.to,
            settore: [], tipContratto: [], commessa: [],
        });
    }, []);

    // Filtri applicati (quelli che passano ai figli)
    const [appliedFilters, setAppliedFilters] = useState({
        fromDate: defaultDates.from,
        toDate: defaultDates.to,
        settore: [],
        tipContratto: [],
        commessa: [],
    });



    return (
        <div className="operazioni-hr-page">
            <header className="oper-hr-header">
                <div className="oper-hr-header-content">
                    <button className="oper-hr-back-btn" onClick={() => navigate('/reportistica')}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="15 18 9 12 15 6"></polyline>
                        </svg>
                        Indietro
                    </button>

                    <div className="oper-hr-header-title">
                        <div className="oper-hr-title-row">
                            <h1>Ambiente</h1>
                            <button className="oper-hr-info-btn" onClick={() => setShowInfoModal(true)} title="Informazioni">
                                <span>i</span>
                            </button>
                        </div>
                        <p className="oper-hr-subtitle">Grafici e tabelle relativi ai dati ambientali</p>
                    </div>
                </div>
            </header>

            {showInfoModal && (
                <div className="oper-hr-modal-overlay" onClick={() => setShowInfoModal(false)}>
                    <div className="oper-hr-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="oper-hr-modal-header">
                            <div className="oper-hr-modal-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <line x1="12" y1="16" x2="12" y2="12"></line>
                                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                                </svg>
                            </div>
                            <h3>Informazioni sulla pagina</h3>
                            <button className="oper-hr-modal-close" onClick={() => setShowInfoModal(false)}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                            </button>
                        </div>
                        <div className="oper-hr-modal-body">
                            <div className="oper-hr-modal-section">
                                <h4>Cosa fa questa pagina?</h4>
                                <p>
                                    Questa pagina permette di analizzare i dati del settore ambiente:
                                    ore lavorate, costi e ricavi per settore e commessa.
                                    Puoi confrontare ore PEI con ore effettive, monitorare costo e ricavo orario
                                    e valutare la redditivita per periodo e area operativa.
                                </p>
                            </div>
                            <div className="oper-hr-modal-section">
                                <h4>Come utilizzarla?</h4>
                                <ul>
                                    <li><strong>Filtri:</strong> Applica filtri per periodo (mese inizio/fine), settore, tipo contratto e commessa</li>
                                    <li><strong>Generale:</strong> Visualizza la tabella KPI per settore con costo orario, costo percentuale e ricavo orario, il grafico combo con ore lavorate, costi e ricavi nel tempo, il grafico a barre per il confronto ore PEI vs ore lavorate e il grafico lineare per costo/ricavo orario e ore totali. Tutti i grafici supportano vista mensile, trimestrale e annuale e il filtro dinamico al click</li>
                                    <li><strong>Dettaglio:</strong> Consulta due tabelle gerarchiche espandibili per settore e commessa: Dettaglio Ore (ore totali, lavorate, PEI e differenza percentuale) e KPI per Settore (ore, costi, costo percentuale e ricavi), con vista mensile con subtotali trimestrali, trimestrale e annuale</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <main className="oper-hr-main">
                <div className="oper-hr-actions">
                    <button
                        type="button"
                        className={`oper-hr-action-btn ${showFiltersPanel ? 'active' : ''}`}
                        onClick={() => setShowFiltersPanel(prev => !prev)}
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
                        </svg>
                        <span>{showFiltersPanel ? 'Nascondi Filtri' : 'Mostra Filtri'}</span>
                    </button>
                </div>

                {showFiltersPanel && (
                    <div className="oper-hr-panel">
                        <div className="oper-hr-filters-grid">
                            <div className="oper-hr-filter-item">
                                <label>Mese Inizio</label>
                                <MonthPickerModal value={dateToMonth(fromDate)} onChange={handleFromMonthChange} max={dateToMonth(toDate) || undefined} label="Mese Inizio" />
                            </div>
                            <div className="oper-hr-filter-item">
                                <label>Mese Fine</label>
                                <MonthPickerModal value={dateToMonth(toDate)} onChange={handleToMonthChange} min={dateToMonth(fromDate) || undefined} label="Mese Fine" />
                            </div>
                            <div className="oper-hr-filter-item">
                                <label>Settore</label>
                                <Select classNamePrefix="oper-hr-select" placeholder="Tutti" value={selectedSettore} options={filterOptions.settore} onChange={setSelectedSettore} isMulti components={{ MultiValue: MultiValueContainer }} hideSelectedOptions={false} closeMenuOnSelect={false} />
                            </div>
                            <div className="oper-hr-filter-item">
                                <label>Tip. Contratto</label>
                                <Select classNamePrefix="oper-hr-select" placeholder="Tutti" value={selectedTipContratto} options={filterOptions.tipContratto} onChange={setSelectedTipContratto} isMulti components={{ MultiValue: MultiValueContainer }} hideSelectedOptions={false} closeMenuOnSelect={false} />
                            </div>
                            <div className="oper-hr-filter-item">
                                <label>Commessa</label>
                                <Select classNamePrefix="oper-hr-select" placeholder="Tutte" value={selectedCommessa} options={filterOptions.commessa} onChange={setSelectedCommessa} isMulti components={{ MultiValue: MultiValueContainer }} hideSelectedOptions={false} closeMenuOnSelect={false} />
                            </div>
                            <div className="oper-hr-filter-actions">
                                <button type="button" className="oper-hr-btn-primary" onClick={handleApply}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    Applica
                                </button>
                                <button type="button" className="oper-hr-btn-secondary" onClick={handleReset}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                                        <path d="M3 3v5h5"></path>
                                    </svg>
                                    Reset
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                <div className="oper-hr-data-section">
                    <FiltroCategorie
                        categories={MOCKED_AMBIENTE_CATEGORIES}
                        filteredCategory={setSelectedCategory}
                        customCss={"reportistica-section"}
                    />
                    {selectedCategory === "Generale" && (
                        <Generale filters={appliedFilters}/>
                    )}
                    {selectedCategory === "Dettaglio" && (
                        <Dettaglio filters={appliedFilters}/>
                    )}
                </div>
            </main>
        </div>
    );
};

export default Ambiente;
